module.exports = {
  ACTIVE: "A",
  SUMMONS: "B",
  CLOSED: "C",
  STOP: "F",
  LAPSED: "L",
  NEW: "N",
  POTENTIAL_WRITE_OFF: "P",
  BAD_DEBT: "W",
};
